module.exports = __webpack_public_path__ + "img/cb-confirm.0610152d.svg";